<template>
  <div id="outer-container">
    <UIControls/>
    <main-graphics/>
  </div>
</template>

<script>
import MainGraphics from './components/MainGraphics.vue'
import UIControls from './components/UIControls.vue'

export default {
  name: 'App',
  components: {
    MainGraphics,
    UIControls
  },
  mounted: function(){
    if(process.env.NODE_ENV === 'development'){
      //
    }
  }
}
</script>

<style>

#outer-container {
  display: flex;
  justify-content: space-between;
  height:100vh;
}
* {
  padding: 0;
  margin: 0;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
